import { IGlobalAction, GlobalsActionType } from "./globals.actions";

export interface IGloablsState {
    privacyPolicyUrl: string;
    linkedInUrl: string;
    copyrightText: string;
    isLoading: boolean;
    error?: string;
}

const initState: IGloablsState = {
    privacyPolicyUrl: "",
    linkedInUrl: "",
    copyrightText: "",
    isLoading: false,
};

export const globalsReducer = (state = initState, action: IGlobalAction) => {
    switch (action.type) {
        case GlobalsActionType.GLOBALS_GET:
            return { isLoading: true, error: undefined };
        case GlobalsActionType.GLOBALS_GET_ERROR:
            return { ...state, error: action.payload.error, isLoading: false };
        case GlobalsActionType.GLOBALS_GET_SUCCESS:
            return { ...state, ...action.payload, isLoading: false };
        default:
            return state;
    }
};
